module.exports = __webpack_public_path__ + "static/turkey-fc71cb6770e3ad1ff46a3a034d3835fd.png";